declare namespace $ {

	type $mol_string_button__hint_bog_blitz_admin_option_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $mol_string_button__value_bog_blitz_admin_option_2 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_option['option_text'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_check_box__title_bog_blitz_admin_option_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_blitz_admin_option_4 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_option['is_correct'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_minor__title_bog_blitz_admin_option_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_admin_option_6 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_option['delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_row__sub_bog_blitz_admin_option_7 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_option['image_section_content'] >
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_image__uri_bog_blitz_admin_option_8 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_option['option_image_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_button_open__title_bog_blitz_admin_option_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open['title'] >
	>
	type $mol_button_open__files_bog_blitz_admin_option_10 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_option['option_image_files'] >
		,
		ReturnType< $mol_button_open['files'] >
	>
	type $mol_button_minor__title_bog_blitz_admin_option_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_admin_option_12 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_option['remove_image'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_row__sub_bog_blitz_admin_option_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	export class $bog_blitz_admin_option extends $mol_list {
		option_content( ): readonly(any)[]
		image_section_content( ): readonly(any)[]
		option_image_uri( ): string
		option_image_files( next?: readonly(any)[] ): readonly(any)[]
		remove_image( next?: any ): any
		option_text( next?: string ): string
		Text( ): $mol_string_button
		is_correct( next?: boolean ): boolean
		Checkbox( ): $mol_check_box
		delete( next?: any ): any
		Delete( ): $mol_button_minor
		rows( ): ReturnType< $bog_blitz_admin_option['option_content'] >
		Image_section( ): $mol_row
		Image_preview( ): $mol_image
		Image_upload( ): $mol_button_open
		Image_remove( ): $mol_button_minor
		Controls( ): $mol_row
	}
	
}

//# sourceMappingURL=option.view.tree.d.ts.map